import { Injectable } from '@angular/core';
import { Auth, signInWithCustomToken } from '@angular/fire/auth';
import { environment } from '../../environments/environment';

const FIREBASE_SIGN_IN_MAX_ATTEMPTS = 3;
const FIREBASE_SIGN_IN_RETRY_DELAYS_MS = [1000, 2000] as const;

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private auth: Auth) {}

  public customToken: string = '';
  async loginLine(site: string, token: string) {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', `Bearer ${token}`);

    const result = await fetch(`${environment.cloudRun.api}/line-auth-login`, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({ site }),
    });

    if (!result.ok) {
      throw new Error(`lineVerifyToken: Failed to get custom token: ${result.statusText}`);
    }

    const response: { status: string; token: string } = await result.json();

    const authUser = await this.signInWithCustomTokenWithRetry(response.token);

    this.customToken = await authUser.user.getIdToken();

    console.log(' this.customToken', this.customToken);

    return authUser;
  }

  /**
   * LINE WebView 或行動網路偶發中斷時，Firebase 會回傳 auth/network-request-failed。
   * 這類錯誤通常是暫時性的，因此最多重試兩次；token 格式、權限等其他錯誤則直接拋出。
   */
  private async signInWithCustomTokenWithRetry(token: string) {
    for (let attempt = 1; attempt <= FIREBASE_SIGN_IN_MAX_ATTEMPTS; attempt += 1) {
      try {
        return await signInWithCustomToken(this.auth, token);
      } catch (error: unknown) {
        const shouldRetry = this.isFirebaseNetworkError(error) && attempt < FIREBASE_SIGN_IN_MAX_ATTEMPTS;

        if (!shouldRetry) {
          throw error;
        }

        console.warn(`Firebase sign-in network error; retrying (${attempt + 1}/${FIREBASE_SIGN_IN_MAX_ATTEMPTS}).`);
        await this.delay(FIREBASE_SIGN_IN_RETRY_DELAYS_MS[attempt - 1]);
      }
    }

    throw new Error('Firebase sign-in failed after retries.');
  }

  private isFirebaseNetworkError(error: unknown): error is { code: 'auth/network-request-failed' } {
    return (
      typeof error === 'object' && error !== null && 'code' in error && error.code === 'auth/network-request-failed'
    );
  }

  private async delay(milliseconds: number) {
    await new Promise<void>((resolve) => window.setTimeout(resolve, milliseconds));
  }
}
